/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getClubData({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/club")
        .then((response) => {
          // commit('SET_CLUB', response.data)
          localStorage.setItem('clubData', JSON.stringify(response.data));
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  getMailData({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewMails", data)
        .then((response) => {
          // commit('SET_CLUB', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  updateMails({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateMails", data)
        .then((response) => {
          // commit('SET_CLUB', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  previewMail({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/previewMail", data)
        .then((response) => {
          // commit('SET_CLUB', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  manageFeedback({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/manageFeedback", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  createModule({ commit }, moduleData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/module/create", moduleData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

}
